// import $ from 'jquery';
// import moment from 'moment';
import * as Funcs from '@utils/legacy-functions'
import Cache from "./utils/Cache";
/**
 * momentjs as global
 */
// Object.assign(window, {moment: moment});

/**
 * Make DateTool adn MoneyTool global until calc-inst.js and calc-workflow.js will be refactored
 */
// import DateTool from '../utils/DateTool';
// import MoneyTool from '../utils/MoneyTool';
// Object.assign(window, {DateTool: new DateTool, MoneyTool:  new MoneyTool});

/**
 * import legacy functions and make them global
 */
Object.assign(window, Funcs);

/**
 * Legacy global variables
 * @todo refactor them
 */
window.at = 400;
window.mobile = false;
window.ios = false;
window.scrollbar_width = 0;
if ($.support.touch) window.mobile = true; //check if we're dealing with mobile
if (mobile) window.ios = /(iPad|iPhone|iPod)/g.test(navigator.userAgent); //check if we're dealing with iOS
window._v = null;
window.generated_click = false;
